import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FontAwesomeIcon from '../../Icon';
import Row from '../../Row';
import Col from '../../Col';
import classNames from 'classnames';
import '../../../layouts/WithNavigation/Sidebar.scss'
import './WalkThroughSideBar.scss';

import { setPropertyWalkThroughFormStep,setPropertyWalkThroughFormPreviousStep, exitPropertyWalkThroughForm,fetchConfigureTypeWalkThroughData } from '../../../store/actions/propertyWalkThroughForm';
import { selectPropertyWalkThroughFormData } from '../../../store/selectors/propertyWalkThroughForm';
import { selectEasyWalkThroughFormData } from '../../../store/selectors/easyWalkThroughForm';
import { selectSuiteById } from '../../../store/selectors/suites';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import { setEasyWalkThroughFormStep,setEasyWalkThroughFormData,exitEasyWalkThroughForm } from '../../../store/actions/easyWalkThroughForm'
import { fetchAreaData, fetchSuiteCheckList } from '../../../store/actions/areas';
import {fetchPropertySuites} from '../../../store/actions/suites';
import Navigation from './Navigation';
import '../../../styles/includes/variables.scss';
import { fetchSuiteWalkThroughs } from '../../../store/actions/walkThroughs'
import { Images } from '../../../Tenants';

class WalkThroughSideBar extends Component {
 
  checkListarea(link,areasCheckList){
    if(areasCheckList.length > 0){
      let data = areasCheckList.filter( area => area.areaId === link.areaId) ? areasCheckList.filter( area => area.areaId === link.areaId) : []
      if(data.length > 0){if( data.length > 0 && data[0].totalChecklist === 0 ){
        return <>
        {/* <div>{ '0/0'}</div>  */}
        </>
      }else{
        if(data[0].totalCheckedChecklist === data[0].totalChecklist ){
          return(
            <div className='documents__headline--walkthroughcompletecheckbox'>
              <FontAwesomeIcon
               glyph="check-circle"
               size="medium"
               weight="light"
              />
            </div>
          )
        }else{
          // return (
          //   <div>{ data[0].totalCheckedChecklist+'/'+data[0].totalChecklist }</div> 
          // ) 
        }
      }
    }else{
      return null
    }
      
      
    }else{
      return null
    }
  }
  
  render() {
    const {from,collapsableSideBar,onCollapsableSideBar, onClickSidebar, user,easyWalkThroughFormData,propertyWalkThroughFormData,suite,areas,onSetEasyWalkThroughFormData,onFetchPropertySuites, onSetPropertyWalkThroughFormPreviousStep,onSetPropertyWalkThroughFormIsVisible,onSetEasyWalkThroughFormStep,onFetchAreaData,onExitEasyWalkThroughForm, onExitPropertyWalkThroughForm,onFetchConfigureTypeWalkThroughData,onFetchSuiteCheckList, onClose,fetchSuiteWalkThroughs } = this.props;
    let width = (190/100);
    //226/220
    let cwidth = 0;
    let totalchecklist = 0;
    let totalcheckedlist =0;
      
    // let rooms = suite.areas&&suite.areas.length > 0 ? suite.areas.map( room => ({ label: room.customLabel ? room.customLabel : room.name ,areaId:room.areaId})) : [{label:'loading',areaId:''}]
    let areasCheckList = []
    if(propertyWalkThroughFormData.sideBarCheckList && propertyWalkThroughFormData.sideBarCheckList.areasCheckList.length > 0){
      totalcheckedlist = propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist;
      totalchecklist = propertyWalkThroughFormData.sideBarCheckList.totalChecklist
      areasCheckList = propertyWalkThroughFormData.sideBarCheckList.areasCheckList
      if(propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist !== 0){

       if(totalcheckedlist === totalchecklist ){
         cwidth = width * 103

       }else{
        let totalCount = propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist/propertyWalkThroughFormData.sideBarCheckList.totalChecklist * 100
        
        
          width = width* totalCount
          cwidth =width
        
       }
      }
    }
    const roleName = user.roles[0].role.name;
    return (
      <div className="sidebar">
            {
              from === "DeveloperWalkThrough" && <Row>
              <Col
                granola
                xs="12"
                md="1"
              >
              <div
                className={
                  classNames(
                    "sidebar__collapsableBar",
                    {
                      "sidebar__collapsableBar--collapsedSideBar":from === "DeveloperWalkThrough"?collapsableSideBar:false
                    }
                  )
                }
              >
                <div onClick={()=>onCollapsableSideBar()} className="sidebar__collapsableBar--Icon">
                <FontAwesomeIcon
                  weight="solid"
                  glyph="bars"
                />
                </div>
              </div>
              </Col>
            </Row>
            }
      <div style={(collapsableSideBar === true && from === "DeveloperWalkThrough")?{display:'none'}:{display:'flex'}} className={
        classNames(
          "sidebar",
          {
            "sidebar--collapsed":from === "DeveloperWalkThrough"?collapsableSideBar:false
          }
        )
      }>  
        <div className="sidebar__top">
          <div className="sidebar__yield">
            <Row>
              <Col
                granola
                xs="12"
                md="1"
              >
               {/* {user.roles[0].role.name === 'Home Owner' ?  */}
               
                  <div
                    style={{
                      color: "white",
                      cursor: 'pointer'
                    }}
                    onClick={
                      () => {
                        onExitEasyWalkThroughForm()
                        onExitPropertyWalkThroughForm()
                        fetchSuiteWalkThroughs(propertyWalkThroughFormData.suiteId, roleName)
                        // onFetchPropertySuites(propertyWalkThroughFormData.propertyId)
                        // onClose()
                      }
                    }
                  >
                    <FontAwesomeIcon
                      weight="light"
                      glyph="arrow-left"
                    />
                  </div>
                {/* : 
                <div style={{ color: "white", cursor: 'pointer' }} onClick ={ ()=> onSetPropertyWalkThroughFormPreviousStep()}>
                  <Icon
                    weight="light"
                    glyph="arrow-left"
                  />
                </div> }  */}
              </Col>
              <Col
                granola
                xs="12"
                md="11"
              >
                <div className="sidebar__tenant">
                  <div className="walkThroughSideBar">
                    <div className="walkThroughSideBar__headline">
                      {propertyWalkThroughFormData.propertyName}
                    </div>
                    <div className="walkThroughSideBar__strapline">
                      {propertyWalkThroughFormData.suiteName}
                    </div>
                    <div className="walkThroughSideBar__strapline">
                      {propertyWalkThroughFormData.propertyAddress}
                    </div>
                    <div className="walkThroughSideBar__strapline">
                      {propertyWalkThroughFormData.propertyCity}
                    </div>
                    <div className="walkThroughSideBar__strapline">
                      {propertyWalkThroughFormData.propertyProvince}
                    </div>
                    <div className="walkThroughSideBar__strapline">
                      {propertyWalkThroughFormData.proeprtyPostalCode}
                    </div>
                     </div>
                </div>
              </Col>
            </Row>
          </div>
         <div>
         {this.props.offline ? null :
        <>
         <div style={{paddingLeft:30}}>
            <Row>
              <Col
                granola
                md="1"
              >
                <div style={{ color: "white"}}>
                  <FontAwesomeIcon
                    weight="light"
                    glyph="key"
                  />
                </div>
              </Col>
              <Col
                granola
                 md="11"
              >
                <div style={{ color: 'white' }}>
                  <div className="walkThroughSideBar">  
                    <div 
                      className="tenant__headline"  
                      style={{ cursor:'pointer'}} 
                      onClick={
                        ()=>{
                          onClickSidebar()
                          onSetEasyWalkThroughFormStep(0); 
                          onSetEasyWalkThroughFormData({areaId:'', areaName: ''});
                          onFetchConfigureTypeWalkThroughData(propertyWalkThroughFormData.walkthroughId)
                        }
                      }
                    >
                        Walk Through
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="walkThroughSideBar__anchor">
            <div className='walkThroughSideBar__progressBar' >
              <div className='walkThroughSideBar__progressBar--bar' style={{ width: cwidth, height: 15,borderRadius:2, }} />
            </div>
            <div style={{paddingLeft:10}}>
             {totalcheckedlist+"/"+totalchecklist}
            </div>
             </div> </>}
          {this.props.offline ? null :

          <ul className="walkThroughSideBar__links">
            {
              areas.length > 0 ? areas.map((link, i) => (
                <li
                  className="navigation__link"
                  key={i}
                >
                  <div
                    className={ classNames(
                      "walkThroughSideBar__anchor",
                       easyWalkThroughFormData.areaId === link.areaId ? "walkThroughSideBar__anchor--active" :  "" 
                      )}
                    style={{cursor:'pointer'}}
                    onClick={ ()  => {
                      onClickSidebar()
                      onSetEasyWalkThroughFormData({areaId:link.areaId, areaName: link.name});
                      onSetEasyWalkThroughFormStep(1); 
                      // onFetchAreaData(link.unitId, link.areaId)
                      onFetchAreaData(propertyWalkThroughFormData.walkthroughId, link.areaId)
                      // onFetchSuiteCheckList(propertyWalkThroughFormData.suiteId)
                      onFetchSuiteCheckList(propertyWalkThroughFormData.walkthroughId)
                    }}
                  > 
                  <div className='walkThroughSideBar__checkListView'>
                    <div>  {link.customLabel ? link.customLabel : link.name}  </div>
                    {this.checkListarea(link,areasCheckList)}
                  </div>
                  </div>
                </li>)) : null
            }
          </ul>
                            }
          </div>
        </div>
        
        {/* <Link
          to={PATHS.AUTH_SIGN_OUT}
          className="navigation__anchor"
          activeClassName="navigation__anchor--active"
          // onClick={() => window.confirm(`Are you sure you want to sign out ?`)}
        >
          <Icon
            weight="light"
            glyph={'sign-out'}
          />
            Sign Out
        </Link> */}
        {this.props.offline ? null :
        <>
  <div class="sidebar__spacer"></div>
  
        <div style={{paddingLeft:"4rem",paddingBottom:"2rem" }}>
        <Navigation
            onSignOut={
              () => {
                onExitEasyWalkThroughForm()
                onExitPropertyWalkThroughForm()
                onFetchPropertySuites(propertyWalkThroughFormData.propertyId, user.id, user.roles[0].role.name)
              }
            }
          />
          </div>
          </>
           }
        <div className="sidebar__bottom">
          <div className="sidebar__brand">
            <div className="sidebar__logo">
              <img
                alt="juniper"
                src={Images.logo}
                height="18"
              />
            </div>
            <div className="sidebar__customer">
              {/* <p>  {ABCD properties}</p> */}
              {/* <p>  {propertyWalkThroughFormData.propertyName}</p> */}
            </div>
          </div>
        </div>
        </div>
      </div>

    )
  }
}



const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state)
  let easyWalkThroughFormData = selectEasyWalkThroughFormData(state)
  let suite = selectSuiteById(state, propertyWalkThroughFormData.suiteId)
 
  return {
      suite,
      propertyWalkThroughFormData,
      easyWalkThroughFormData,
      user: selectAuthenticatedUser(state),
      areas: state.areas
    };
};


const mapDispatchToProps = dispatch => bindActionCreators({
  
  onSetPropertyWalkThroughFormPreviousStep: setPropertyWalkThroughFormPreviousStep,
  onSetPropertyWalkThroughFormStep:setPropertyWalkThroughFormStep,
  // onSetPropertyWalkThroughFormIsVisible:setPropertyWalkThroughFormIsVisible,
  onExitEasyWalkThroughForm:exitEasyWalkThroughForm,
  onExitPropertyWalkThroughForm:exitPropertyWalkThroughForm,

  onFetchConfigureTypeWalkThroughData:fetchConfigureTypeWalkThroughData,

  onSetEasyWalkThroughFormStep: setEasyWalkThroughFormStep,
  onSetEasyWalkThroughFormData:setEasyWalkThroughFormData,
  onFetchAreaData:fetchAreaData,
  onFetchSuiteCheckList:fetchSuiteCheckList,
  onFetchPropertySuites: fetchPropertySuites,
  fetchSuiteWalkThroughs
  
}, dispatch);




// WalkThroughSideBar.propTypes = {}
export default connect( mapStateToProps,mapDispatchToProps)(WalkThroughSideBar)